export default "__VITE_ASSET__BsKrJeSC__"